import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter } from "lucide-react";

const SOCIALS = [
  { label: "INSTAGRAM", icon: Instagram, href: "https://instagram.com/qontri" },
  { label: "X / TWITTER", icon: Twitter, href: "https://x.com/qontri" },
  { label: "LINKEDIN", icon: Linkedin, href: "https://linkedin.com/company/qontri" },
];

const LEGAL = [
  { l: "PRIVACY POLICY", h: "/privacy" },
  { l: "TERMS OF SERVICE", h: "/terms" },
  { l: "DELETE ACCOUNT", h: "/delete-account" },
];

export default function Footer() {
  return (
    <footer
      id="footer"
      data-testid="footer-section"
      className="relative bg-[#0F2C5A] text-[#F0EAFD] pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5 min-w-0">
            <a
              href="/"
              className="font-display leading-[0.85] block text-[#F0EAFD] truncate text-[clamp(2.5rem,6vw,5rem)]"
              data-testid="footer-logo"
            >
              QONTRI<span className="text-[#3056F5]">.</span>
            </a>
            <p className="mt-6 max-w-md text-[#F0EAFD]/70 text-base">
              Your travel buddy for smart contributions and simple settlements.
              Built for crews that travel together — and split fairly.
            </p>
            <p className="mt-4 text-[#F0EAFD]/50 text-sm">
              Need help? Reach us at{" "}
              <a
                href="mailto:support@qontri.in"
                className="text-[#F0EAFD] hover:text-[#3056F5] transition-colors underline-offset-4 hover:underline"
                data-testid="footer-support-email"
              >
                support@qontri.in
              </a>
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-[11px] tracking-[0.3em] font-bold text-[#F0EAFD]/50 mb-5">
                EXPLORE
              </p>
              <ul className="space-y-3">
                {[
                  { l: "HOME", h: "/#home" },
                  { l: "ABOUT APP", h: "/#about" },
                  { l: "FEATURES", h: "/#features" },
                ].map((i) => (
                  <li key={i.l}>
                    <a
                      href={i.h}
                      data-testid={`footer-link-${i.l.toLowerCase().replace(" ", "-")}`}
                      className="text-[#F0EAFD] hover:text-[#3056F5] transition-colors text-sm font-semibold tracking-widest"
                    >
                      {i.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="text-[11px] tracking-[0.3em] font-bold text-[#F0EAFD]/50 mb-5">
                LEGAL
              </p>
              <ul className="space-y-3">
                {LEGAL.map((i) => (
                  <li key={i.l}>
                    <Link
                      to={i.h}
                      data-testid={`footer-legal-${i.h.replace("/", "")}`}
                      className="text-[#F0EAFD] hover:text-[#3056F5] transition-colors text-sm font-semibold tracking-widest"
                    >
                      {i.l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-span-2 md:col-span-1">
              <p className="text-[11px] tracking-[0.3em] font-bold text-[#F0EAFD]/50 mb-5">
                SOCIAL
              </p>
              <ul className="space-y-3">
                {SOCIALS.map((s) => {
                  const Icon = s.icon;
                  return (
                    <li key={s.label}>
                      <a
                        href={s.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                        className="inline-flex items-center gap-3 text-[#F0EAFD] hover:text-[#3056F5] transition-colors text-sm font-semibold tracking-widest"
                      >
                        <Icon className="w-4 h-4" />
                        {s.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F0EAFD]/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p
            data-testid="footer-copyright"
            className="text-[#F0EAFD]/60 text-sm tracking-wide"
          >
            © {new Date().getFullYear()} Qontri. All rights reserved. ·{" "}
            <a
              href="https://qontri.in"
              className="underline underline-offset-4 hover:text-[#3056F5]"
            >
              qontri.in
            </a>
          </p>
          <p className="text-[#F0EAFD]/40 text-xs tracking-[0.25em] font-bold">
            MADE IN INDIA · BUILT FOR THE CREW
          </p>
        </div>
      </div>
    </footer>
  );
}
